import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({
  custom: {
    palette: { colorSupportPowder, colorSuccess },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    button: {
      borderRadius: unit / 2,
      cursor: 'pointer',
      display: 'inline-block',
      margin: `0px ${unit / 2}px`,
      padding: `0px ${unit}px`,
      '&:hover': {
        background: colorSupportPowder,
      },
    },
    copyWrapper: {
      width: 84,
      display: 'flex',
      alignItems: 'center',

      '& > span': {
        height: '100%',
      },
    },
    icon: {
      fontSize: 17,
      color: colorSuccess,
      marginLeft: unit / 2,
      position: 'relative',
      top: -2,
    },
    label: {
      width: 100,
      marginRight: unit * 2,
      whiteSpace: 'nowrap',
    },
    link: {
      flex: 1,
    },
    root: {
      display: 'flex',
      flex: 1,
    },
    text: {
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
    },
  });
